import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import apiUser from "app/api/user";
import {useAppSelector} from "hooks/useAppSelector";
import { updateUserInfo } from "app/store/slices/user";
import { getAvatarUrl } from "app/utils/help";

export const useProfilePanelData = () => {
    const { $t } = useIntl();
    const user = useAppSelector((state) => state.user.user);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [verified, setIsVerified] = useState(false);
    const dispatch = useDispatch();

    const userData = useMemo(() => {
        return {
            avatar: getAvatarUrl(user?.header || "") || "",
            email: user?.email || $t({ id: 'ThereIsNoData' }),
            email_verified: user?.emailStatus === 1,
            id: user?.userId + "" || "",
            name: user?.nick || "",
        };
    }, [user]);

    useEffect(() => {
        const isVerified = !!(user?.address || user?.birth || user?.firstName || user?.lastName);
        setIsVerified(isVerified);
    }, [user]);

    const updateNick = async (nick: string) => {
        const res = await apiUser.modifyUserName(nick);
        if (res.status === 200 && res.data.code === 0) {
            dispatch(updateUserInfo({ nick: nick }));
        }
    };

    return {
        userData,
        updateNick,
        isModalOpen,
        setIsModalOpen,
        verified,
        setIsVerified
    }
}